export default __webpack_public_path__ + "static/2129-c30af7e01b9cac33448eac87db3135d1.gif";